import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import Title from './Title';
import { FaStar } from 'react-icons/fa';

const WriteReview = ({ productId, backendUrl, token, fetchReviews }) => {
  const [guestName, setGuestName] = useState('');
  const [guestEmail, setGuestEmail] = useState('');
  const [reviewRating, setReviewRating] = useState(0);
  const [reviewComment, setReviewComment] = useState('');
  const [isSubmittingReview, setIsSubmittingReview] = useState(false);

  const submitReview = async () => {
    if (!reviewRating || !reviewComment || (!token && (!guestName || !guestEmail))) {
      toast.error('All fields are required.', { position: 'bottom-right', autoClose: 3000 });
      return;
    }

    try {
      setIsSubmittingReview(true);

      const reviewData = token
        ? { productId, rating: reviewRating, comment: reviewComment }
        : { productId, rating: reviewRating, comment: reviewComment, guestName, guestEmail };

      const response = await axios.post(
        `${backendUrl}/api/review/submitreview`,
        reviewData,
        token ? { headers: { Authorization: `Bearer ${token}` } } : {}
      );

      const data = response.data;
      if (data.success) {
        toast.success('Review submitted successfully!', {
          position: 'bottom-right',
          autoClose: 3000,
        });
        setGuestName('');
        setGuestEmail('');
        setReviewRating(0);
        setReviewComment('');
        fetchReviews();
      } else {
        toast.error(data.message, { position: 'bottom-right', autoClose: 3000 });
      }
    } catch (error) {
      toast.error('Failed to submit review. Please try again.', {
        position: 'bottom-right',
        autoClose: 3000,
      });
    } finally {
      setIsSubmittingReview(false);
    }
  };

  const renderStars = () => {
    return (
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5].map((num) => (
          <button
            key={num}
            onClick={() => setReviewRating(num)}
            className="focus:outline-none transition-transform duration-200 hover:scale-110"
            aria-label={`Rate ${num} stars`}
          >
            <FaStar
              className={`w-5 h-5 transition-colors duration-200 ${
                reviewRating >= num ? 'text-[#4c0f2e]' : 'text-[#e0c3b5]'
              }`}
            />
          </button>
        ))}
        {reviewRating > 0 && (
          <span className="text-[#4c0f2e] text-sm ml-2">({reviewRating}/5)</span>
        )}
      </div>
    );
  };

  return (
    <div className="border border-[#4c0f2e] rounded-lg p-6 mt-6">
      <div className="mb-6">
        <Title text1={'WRITE A '} text2={'REVIEW'} />
      </div>

      <div className="space-y-5">
        {/* Guest Information */}
        {!token && (
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-[#2d161e] text-sm font-medium mb-2">Name *</label>
              <input
                type="text"
                placeholder="Enter your name"
                value={guestName}
                onChange={(e) => setGuestName(e.target.value)}
                className="w-full px-3 py-2 border border-[#e0c3b5] rounded-md 
                         text-[#2d161e] placeholder-[#b09287] text-sm
                         focus:outline-none focus:border-[#4c0f2e]
                         transition-colors duration-200"
              />
            </div>
            <div>
              <label className="block text-[#2d161e] text-sm font-medium mb-2">Email *</label>
              <input
                type="email"
                placeholder="Enter your email"
                value={guestEmail}
                onChange={(e) => setGuestEmail(e.target.value)}
                className="w-full px-3 py-2 border border-[#e0c3b5] rounded-md 
                         text-[#2d161e] placeholder-[#b09287] text-sm
                         focus:outline-none focus:border-[#4c0f2e]
                         transition-colors duration-200"
              />
            </div>
          </div>
        )}

        {/* Rating */}
        <div>
          <label className="block text-[#2d161e] text-sm font-medium mb-2">Rating *</label>
          {renderStars()}
        </div>

        {/* Review Comment */}
        <div>
          <label className="block text-[#2d161e] text-sm font-medium mb-2">Your Review *</label>
          <textarea
            className="w-full px-3 py-2 border border-[#e0c3b5] rounded-md 
                     text-[#2d161e] placeholder-[#b09287] text-sm h-24
                     focus:outline-none focus:border-[#4c0f2e]
                     transition-colors duration-200 resize-none"
            placeholder="Share your thoughts about this product..."
            value={reviewComment}
            onChange={(e) => setReviewComment(e.target.value)}
          />
        </div>

        {/* Submit Button */}
        <button
          onClick={submitReview}
          disabled={isSubmittingReview}
          className={`px-6 py-2 rounded-md text-sm font-medium
                    transition-all duration-200 ${
                      isSubmittingReview
                        ? 'bg-[#b09287] text-white cursor-not-allowed'
                        : 'bg-[#4c0f2e] text-white hover:bg-[#2a081a]'
                    }`}
        >
          {isSubmittingReview ? 'Submitting...' : 'Submit Review'}
        </button>
      </div>
    </div>
  );
};

export default WriteReview;
